export default "/dist/files/challenge.7f7fe80113b820c70ce42d8b121fa90d.svg";